import PropTypes from "prop-types";
import React from "react";

import SendHelpForm from "v2/components/responsive/SendHelpForm";

const SendHelpPage = (props, context) => {
  const {location: {query}, params: {date, id, routeId}, router} = context;
  return (
    <SendHelpForm
      onCancel={(evt) => {
        evt.preventDefault();
        router.push({
          pathname: `/${date}/${routeId}/${id}`,
          query,
        });
      }} />
  );
};

SendHelpPage.contextTypes = {
  location: PropTypes.object,
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
  router: PropTypes.object,
};

export default SendHelpPage;



/** WEBPACK FOOTER **
 ** ./src/app/v2/pages/SendHelpPage.js
 **/